import {Component, Input, OnInit, Inject} from '@angular/core';
import { StateService } from '@uirouter/core';
import { LocalStorageService } from 'angular-2-local-storage';
import {AppService} from "../../utils/app.service";

@Component({
    selector: 'main-page',
    template: require('./empty.html'),
})

export class MainPageComponent implements OnInit{
    private app: any;
    constructor(
        private Location:StateService,
        @Inject(AppService) public AppService,
        private localStorageService: LocalStorageService
    ){}
    
    @Input() params : any;

    ngOnInit(){
        this.app = this.AppService;
        if (!this.params.client_id) {
            this.app.setDefaultParams();
        } else {
            this.localStorageService.set('params', this.params);
        }
        if (this.params.page) {
            this.Location.go(this.params.page,{});
        }else if (this.params.error) {
            this.Location.go('login',{error:this.params.error});
        } else {
            this.Location.go('login',{auth:this.params.oauth});
        }
    }
}